var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "wa-business-daily-usage" },
    [
      _vm.loading
        ? _c("md-progress-bar", { attrs: { "md-mode": "indeterminate" } })
        : _vm._e(),
      _vm._v(" "),
      _c("div", { staticClass: "header" }, [
        _c("div", { staticClass: "title" }, [
          _vm._v(_vm._s(_vm.$t("whatsapp_business_api.dailyUsageReport"))),
        ]),
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "title" }, [
        _vm._v(_vm._s(_vm.$t("whatsapp_business_api.dailyUsageReport")) + "."),
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "table-toolbar" }, [
        _c("div", { staticClass: "date-filter d-flex gap-5" }, [
          _c("i", { staticClass: "material-icons" }, [_vm._v("date_range")]),
          _vm._v(" "),
          _c(
            "select",
            {
              directives: [
                {
                  name: "model",
                  rawName: "v-model",
                  value: _vm.timeSelect,
                  expression: "timeSelect",
                },
              ],
              attrs: { id: "time-select" },
              on: {
                change: [
                  function ($event) {
                    var $$selectedVal = Array.prototype.filter
                      .call($event.target.options, function (o) {
                        return o.selected
                      })
                      .map(function (o) {
                        var val = "_value" in o ? o._value : o.value
                        return val
                      })
                    _vm.timeSelect = $event.target.multiple
                      ? $$selectedVal
                      : $$selectedVal[0]
                  },
                  function ($event) {
                    return _vm.setCustomDateFilter(_vm.timeSelect)
                  },
                ],
              },
            },
            [
              _c("option", { attrs: { value: "today" } }, [
                _vm._v(_vm._s(_vm.$t("time.today"))),
              ]),
              _vm._v(" "),
              _c("option", { attrs: { value: "yesterday" } }, [
                _vm._v(_vm._s(_vm.$t("time.yesterday"))),
              ]),
              _vm._v(" "),
              _c("option", { attrs: { value: "current-week" } }, [
                _vm._v(_vm._s(_vm.$t("time.currentWeek"))),
              ]),
              _vm._v(" "),
              _c("option", { attrs: { value: "last-week" } }, [
                _vm._v(_vm._s(_vm.$t("time.lastWeek"))),
              ]),
              _vm._v(" "),
              _c("option", { attrs: { value: "current-month" } }, [
                _vm._v(_vm._s(_vm.$t("time.currentMonth"))),
              ]),
              _vm._v(" "),
              _c("option", { attrs: { value: "last-month" } }, [
                _vm._v(_vm._s(_vm.$t("time.lastMonth"))),
              ]),
              _vm._v(" "),
              _c("option", { attrs: { value: "last-30" } }, [
                _vm._v(_vm._s(_vm.$t("time.last30Day"))),
              ]),
              _vm._v(" "),
              _vm._l(_vm.getLast11Months(), function (m, i) {
                return _c("option", { key: i, domProps: { value: m.date } }, [
                  _vm._v(
                    "\n                    " +
                      _vm._s(m.name) +
                      "\n                "
                  ),
                ])
              }),
            ],
            2
          ),
        ]),
        _vm._v(" "),
        _c(
          "div",
          { staticClass: "d-flex justify-content-end w-100" },
          [
            _c("a-pagination", {
              key: Math.random(),
              attrs: {
                size: "small",
                total: _vm.total,
                "show-total": function (total) {
                  return "Total " + total + " record"
                },
                "show-size-changer": "",
                "show-quick-jumper": "",
                pageSizeOptions: [
                  "10",
                  "20",
                  "50",
                  "100",
                  "300",
                  "500",
                  "1000",
                ],
                defaultPageSize: _vm.maxResult,
                disabled: _vm.loading,
              },
              on: {
                showSizeChange: function (current, size) {
                  return (_vm.maxResult = size)
                },
              },
              model: {
                value: _vm.currentPage,
                callback: function ($$v) {
                  _vm.currentPage = $$v
                },
                expression: "currentPage",
              },
            }),
          ],
          1
        ),
      ]),
      _vm._v(" "),
      _c("a-table", {
        attrs: {
          columns: _vm.columns,
          "data-source": _vm.getRows(),
          pagination: false,
          "row-key": "date",
          size: "small",
          rowClassName: _vm.getRowClassName,
        },
        scopedSlots: _vm._u([
          {
            key: "date",
            fn: function (text, record) {
              return _c("span", {}, [
                _vm._v(
                  "\n            " +
                    _vm._s(_vm.$moment(record.date).format("YYYY-MM-DD")) +
                    "\n        "
                ),
              ])
            },
          },
          {
            key: "price",
            fn: function (text, record) {
              return _c("span", {}, [
                _vm._v(
                  "\n            " + _vm._s(_vm.getPrice(record)) + "\n        "
                ),
              ])
            },
          },
        ]),
      }),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }